import { isNumber, isFinite } from 'lodash';
export const isPixelValue = (value) => /(px)/.test(value);
export const isPercentageValue = (value) => /%/i.test(value);
export const isNumeric = (value) => {
    const parsedValue = parseFloat(value);
    if (`${parsedValue}` !== `${value}`) {
        return false;
    }
    return isNumber(parsedValue) && isFinite(parsedValue);
};
export const isNumericValueWithUnits = (value) => `${parseFloat(value)}` !== `${value}`;
const lowerCaseString = (value) => typeof value === 'string' ? value.toLowerCase() : value;
export const getPxValue = (value) => {
    if ([isPixelValue, isPercentageValue, isNumeric].some((validator) => validator(lowerCaseString(value)))) {
        return `${value}${isNumericValueWithUnits(value) ? '' : 'px'}`
            .toLowerCase()
            .replace(/\s+/g, '');
    }
    else {
        return '0px';
    }
};
//# sourceMappingURL=line-height-to-px.js.map